import _ from "lodash";

const addThousands = (str: string) =>
  _.chain(str)
    .split("")
    .reverse()
    .chunk(3)
    .map((c) => c.reverse().join(""))
    .reverse()
    .join(".")
    .valueOf();

const Money = ({ cents, className }: { cents: number; className: string }) => (
  <span className={className}>
    {addThousands(_.padStart(cents.toString(), 3, "0").slice(0, -2))},
    {_.padStart(cents.toString(), 3, "0").slice(-2)}
  </span>
);

export default Money;
